import frame from "./frame.png";

const Frames = [frame];
export default Frames;
